export default "__VITE_ASSET__C1iScg5m__"